import React from 'react';
import { Row, Table } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';
import FieldItem from 'components/add_order/order/OrderDetail/OrderReturns/FieldItem';

import { TIME_OPTION } from 'constants/time';
import { formatStatus } from 'utils/valueFormatters';
import { getInventoryBadgeColor } from 'constants/inventory';

const OrderReturnExpandedRow = ({ shipment }) => {
  return (
    <div className="p-3 bg-white border-bottom">
      <Row>
        <FieldItem
          label="Return Manifest"
          value={shipment.return_manifest?.return_manifest_code}
        />

        <FieldItem label="Return Code" value={shipment.return_code} />

        <FieldItem label="AWB No." value={shipment.awb_number} />

        <FieldItem label="Shipment Code" value={shipment.shipment_code} />

        <FieldItem label="Shipment Status" value={shipment.shipment_status} />

        <FieldItem
          label="Shipping Provider"
          value={shipment.shipping_provider?.shipping_provider_type}
        />

        <FieldItem
          label="Return Acknowledged At"
          value={
            shipment.return_acknowledged_at
              ? new Date(shipment.return_acknowledged_at).toLocaleString(
                  'en-IN',
                  TIME_OPTION,
                )
              : ''
          }
        />

        <FieldItem
          label="Returned At"
          value={
            shipment.returned_at
              ? new Date(shipment.returned_at).toLocaleString(
                  'en-IN',
                  TIME_OPTION,
                )
              : ''
          }
        />

        <FieldItem label="Return Comments" value={shipment.return_comments} />
      </Row>

      {shipment?.lines?.length > 0 && (
        <Table size="sm" className="mt-4">
          <thead className="bg-200">
            <tr>
              <th className="text-start pe-3">Item</th>
              <th className="text-start pe-3">SKU</th>
              <th className="text-start pe-3">Status</th>
              <th className="text-center pe-3">Return Inventory Category</th>
              <th className="text-start">Shelf Code</th>
              <th className="text-start">Warehouse</th>
            </tr>
          </thead>
          <tbody>
            {shipment.lines.map(line => (
              <tr key={line.id}>
                <td className="text-start pe-3">{line.product?.name}</td>
                <td className="text-start pe-3">{line.product?.sku}</td>
                <td className="text-start pe-3">{line.shipment_line_status}</td>
                <td className="text-center pe-3">
                  <SubtleBadge
                    pill
                    bg={getInventoryBadgeColor(
                      line.return_inventory_type || 'a',
                    )}
                  >
                    {formatStatus(line.return_inventory_type || 'a')}
                  </SubtleBadge>
                </td>
                <td className="text-start">
                  {line.product_batch?.shelf?.code || '-'}
                </td>
                <td className="text-start">
                  {line.product_batch?.warehouse?.name || '-'}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default OrderReturnExpandedRow;
